import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody50.css';

import clientimg from '../images/case-study-client50.webp'
import outcome from '../images/outcome50.webp'

import sm1 from '../images/cs50so1.webp'
import sm2 from '../images/cs50so2.webp'
import sm3 from '../images/cs50so3.webp'
import sm4 from '../images/cs50so4.webp'


const Casestudybody50 = () => {

    return (
        <>
        <section className='casestudybody50-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a PE firm focused on consumer and business services, combining thematic investing with deep operational expertise to scale service businesses and deliver strong, sustainable returns for investors</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>Conducted preliminary due diligence on a target company to assess strategic, financial, and operational strengths. Built a detailed deal model using client assumptions and company data (financials, CIM, customer metrics, capital structure), supported by market research to validate industry trends and growth potential.</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody50-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Room Review:</h4>
                          <p>Gained access to key documents including <span style={{color:"#03A393",fontWeight:700}}> financial statements, Quality of Earnings (QoE) report, Confidential Information Memorandum (CIM), customer and sales data,</span> and <span style={{color:"#03A393",fontWeight:700}}> capital structure details</span></p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Custom Business Due Diligence Cuts:</h4>
                          <p>Leveraged this data to create <span style={{color:"#03A393",fontWeight:700}}> tailored financial</span> and <span style={{color:"#03A393",fontWeight:700}}> operational analyses</span>, enabling a deeper understanding of <span style={{color:"#03A393",fontWeight:700}}> business performance</span> and supporting the <span style={{color:"#03A393",fontWeight:700}}> broader investment evaluation</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Industry Assessment:</h4>
                          <p>Conducted a thorough evaluation of the <span style={{color:"#03A393",fontWeight:700}}> relevant sector,</span> including <span style={{color:"#03A393",fontWeight:700}}> market sizing, key growth drivers, value chain analysis, competitive landscape mapping,</span> assessment of <span style={{color:"#03A393",fontWeight:700}}> market fragmentation</span> vs <span style={{color:"#03A393",fontWeight:700}}> consolidation</span>, and review of recent <span style={{color:"#03A393",fontWeight:700}}> M&A activity</span></p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Deal Model:</h4>
                          <p>Developed an <span style={{color:"#03A393",fontWeight:700}}> integrated financial model</span> incorporating <span style={{color:"#03A393",fontWeight:700}}> historical, operating metrics,</span> and <span style={{color:"#03A393",fontWeight:700}}> diligence insights;</span> built <span style={{color:"#03A393",fontWeight:700}}> detailed forecasts, structured sources & uses, modelled ownership and returns,</span> and performed <span style={{color:"#03A393",fontWeight:700}}> sensitivity analyses</span> to evaluate investor returns across scenarios</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Investment Memo:</h4>
                          <p>Created a concise <span style={{color:"#03A393",fontWeight:700}}> investment memorandum</span> consolidating key insights from business <span style={{color:"#03A393",fontWeight:700}}> due diligence, industry analysis,</span> and <span style={{color:"#03A393",fontWeight:700}}> deal model.</span> The memo highlighted <span style={{color:"#03A393",fontWeight:700}}> core findings, market outlook,</span> and <span style={{color:"#03A393",fontWeight:700}}> return expectations,</span> providing a clear view of how the opportunity aligned with the client's investment thesis</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody50-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a comprehensive investment package including a robust deal model and strategic memo that enabled the client to evaluate the opportunity’s fit with their investment strategy. The analysis provided clarity on financial performance, market positioning & return potential, supporting a confident and informed investment decision</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody50
